<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      :table_width="1800"
      title="상담신청 조회"
      desc="현재 전체로 들어온 상담신청내역을 확인할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="2000"
                 nextPageName="nopage"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="counsel_content" slot-scope="props">
        <div @click.stop.prevent="clickContent(props.item)" style="cursor: pointer">
          <i class="material-icons">library_books</i>
        </div>
      </div>

      <div slot="is_user" slot-scope="props">
        <div v-if="props.item.user">회원</div>
        <div v-else>비회원</div>
      </div>

      <div slot="user_name" slot-scope="props">
        <span v-if="props.item.user">{{ props.item.user.name }}</span>
      </div>

      <div slot="product" slot-scope="props">
        {{ props.item.product.id }}
      </div>

      <div slot="product_name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="clickDetail(props.item.product.id, 'product')">{{ props.item.product_name }}</span>
      </div>


      <!-- 신청 확인 -->
      <div slot="request_status" slot-scope="props" style="width: 120px; margin: auto;">
        <button class="button request-status" @click="clickAccept(props.item)" v-if="props.item.status===0">확인하기</button>
        <div v-if="props.item.status>0">
          <div>신청확인</div>
          <div>{{ props.item.request_time }}</div>
        </div>
      </div>


      <!-- 상담 확인 -->
      <div slot="counsel_status" slot-scope="props" style="width: 120px; margin: auto;">
        <button class="button counsel-status" @click="clickCounsel(props.item)" v-if="props.item.status===1">상담하기</button>
        <button class="button counsel-status" @click="clickCounsel(props.item)" v-if="props.item.status>1">상세보기</button>
        <div v-if="props.item.status>1">
          <div>상담완료</div>
          <div>{{ props.item.counsel_time }}</div>
        </div>
      </div>

      <!-- 주문 확인 -->
      <div slot="order_status" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-if="props.item.status===3">
          <span v-if="props.item.call_data.is_order">주문(예약)</span>
          <span v-else>비주문</span>
        </div>
      </div>
    </admin-table>

    <!-- 상담 신청서 모달 -->
    <modal name="requestModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상담 신청서 조회" :useTab="false" v-if="selectedItem">
          <div v-for="(form,idx) in selectedItem.forms" :key="'form-'+idx">
            <admin-form-item :label="form.title">
              <div v-for="(res,idx) in form.answers.result" :key="'res-'+idx" class="lp-meet-qna">
                <div>{{ idx+1 }}. {{ res.question }}</div>
                <div v-if="typeof(res.answer)==='string'">{{ res.answer }}</div>
                <div v-else>
                  <div class="align-center flex" v-for="(item,idx) in res.answer" :key="'item-'+idx" style="margin-bottom:4px">
                    <a style="padding-bottom:8px;font-size:13px;text-decoration:underline" :href="item.file" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
              </div>
            </admin-form-item>
          </div>
        </admin-box-item>
      </div>
    </modal>


  </div>
</template>

<script>
  import moment from 'moment';
  import ListMixin from '@/mixins/ListMixin';

  export default {
    name: 'CounselRequestAll',
    mixins: [
      ListMixin
    ],

    computed: {
      partnerName(){
        let partner_id;
        if(this.selectedItem){
          partner_id = this.selectedItem.partner_id;
        }
        else if(this.requestItem){
          partner_id = this.requestItem.partner_id;
        }
        let partner = find(this.partners, 'value', partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },

    data () {
      return {
        selectedItem: undefined,    // 팝업으로 표시할 선택된 아이템
        partners: []
      }
    },

    created () {
      this.init();
    },

    methods: {
      init() {
        this.initializing('counsel_request', 'counsel/request');
        this.$root.$emit('menus');
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      clickDetail(id, type) {
        if( type === 'product' ) {
          window.open(this.getPath(`product/create?id=${id}`));
        }
      },
      clickStatus(item, kind) {
        if (kind === "confirm-new") {
          this.chkReq(item);
        }
        else if (kind === "request-sheet") {
          this.clickAddRequest(item);
        }
        else if (kind === "write-sheet") {
          this.clickAddBid(item);
        }
      },

      // 상담 신청서 보기
      clickContent(item) {
        this.selectedItem = item;
        this.$modal.show('requestModal');
      },

      // 신청 확인하기
      clickAccept(item) {
        this.$axios.post(this.getUrl(`counsel/request/${item.id}/accept`)).then(res=>{
          if(res.status===200) {
            item.status=1;
            item.request_time = moment().format('YYYY-MM-DD HH:mm')
          }
        })
      },

      // 상담하기 클릭
      clickCounsel(item) {
        // call 있을 경우
        if( item.call ) {
          // 회원일 경우
          if ( item.user.id ){
            this.$router.push(this.getPath('cs/call/create?id=' + item.call + '&user_id=' +item.user.id + '&counsel_request_id=' + item.id + '&types=counsel'));
          }
          // 비회원
          else {
            this.$router.push(this.getPath('cs/call/create?id=' + item.call + '&counsel_request_id=' + item.id + '&types=counsel'));
          }
        }
        // 새로 등록하는 경우
        else {
          // 회원일 경우
          if ( item.user.id ) {
            this.$router.push(this.getPath('cs/call/create?user_id=' + item.user.id + '&counsel_request_id=' + item.id + '&types=counsel'));
          }

          // 비회원
          else {
            this.$router.push(this.getPath('cs/call/create?counsel_request_id=' + item.id + '&types=counsel'));
          }
        }
      },


      // 견적 상태 - 신규요청확인 클릭
      chkReq(item) {
        this.$axios.post(this.getUrl('counsel/request/'+item.id+'/receipt'),{
          status:1
        }).then(res => {
          if(res.status===200){
            item.status = 1;
          }
        });
      },
    },
    beforeDestroy() {
      this.$root.$off("menus");
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-counsel-qna
    margin-bottom 12px

  .lp-counsel-qna:last-child
    margin-bottom 0

  .request-status
    background-color #fcb100
    color white

  .counsel-status
    background-color $primary
    color white
</style>
